import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = () => {
    const { isAuthenticated } = useSelector((state: any) => state.auth);
    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export const PublicRoute = () => {
    const { isAuthenticated } = useSelector((state: any) => state.auth);
    return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" replace />;
};
